module.exports = __webpack_public_path__ + "img/out_org_zly.3bd66e98.jpg";